<div class="pagination" *ngIf="totalPage > 1">
  <div
    class="before"
    (click)="onBeforeClick()"
    [ngClass]="{ 'disable-button': selectedPage === 1 }"
  >
    قبلی
    <nb-icon icon="arrow-ios-back-outline"></nb-icon>
  </div>
  <div
    class="page"
    *ngFor="let page of pages"
    [ngClass]="{ 'selected-page': page === selectedPage }"
    (click)="onPageClick(page)"
  >
    {{ page }}
  </div>
  <div
    class="next"
    (click)="onNextClick()"
    [ngClass]="{ 'disable-button': totalPage === selectedPage }"
  >
    <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
    بعدی
  </div>
</div>
